import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, Edit } from "lucide-react";
import styles from "./index.module.scss";

// import hdbMsd from "../../../assets/images/hdbMsd.png";
// import entrainment from "../../../assets/images/entrainment.png";
// import tat from "../../../assets/images/tat.png";
import { endPoints } from "../../../constants/urlConstants";
import { getCall } from "../../../services/apiService";
import { getProgramImage } from "../../../utils/commonFunctions";
import ArrowLeft from "../../../assets/images/arrow-left.svg";
import table from "../../../assets/images/table.svg"; // Assuming you have a table image for the new program option
import sparkle from "../../../assets/images/sparkle.svg"; // Assuming you have a sparkle image for the custom program option
import Loader from "../../../common/components/Loader";

const ChooseProgramPage = ({ onBack }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [programTypesData, setProgramTypesData] = useState([]);
  const fetchProgramsList = () => {
    setLoading(true);

    getCall(`${endPoints.programType}?limit=100&offset=0&searchText=`)
      .then((response) => {
        console.log("API Response:", response);

        if (response?.data?.data) {
          console.log("Fetched Program Types:", response.data.data);
          // setLoading(false);
          // Store the original program types data
          setProgramTypesData(response.data.data.data);

          // Extract all programs from the nested structure
        } else {
          console.error("No data found in response");
        }
      })
      .catch((error) => {
        console.error("Error fetching programs:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchProgramsList();
  }, []);
  // Function to get the appropriate image based on program type name
  // const getProgramImage = (programTypeName) => {
  //   const name = programTypeName.toLowerCase();
  //   if (name.includes('hdb') || name.includes('msd')) {
  //     return hdbMsd;
  //   } else if (name.includes('entertainment') || name.includes('entrainment')) {
  //     return entrainment;
  //   } else if (name.includes('tat')) {
  //     return tat;
  //   }
  //   return hdbMsd; // Default image
  // };

  // Function to get CSS class based on program type
  const getProgramClass = (programTypeName) => {
    const name = programTypeName.toLowerCase();
    if (name.includes("hdb") || name.includes("msd")) {
      return "hdb";
    } else if (name.includes("entertainment") || name.includes("entrainment")) {
      return "entrainment";
    } else if (name.includes("tat")) {
      return "tat";
    }
    return "hdb"; // Default class
  };

  // Function to get background color based on program type
  const getProgramColors = (programTypeName) => {
    const name = programTypeName.toLowerCase();
    if (name.includes("hdb") || name.includes("msd")) {
      return { bgColor: "bg-red-600", textColor: "text-white" };
    } else if (name.includes("entertainment") || name.includes("entrainment")) {
      return { bgColor: "bg-blue-200", textColor: "text-gray-800" };
    } else if (name.includes("tat")) {
      return { bgColor: "bg-amber-900", textColor: "text-white" };
    }
    return { bgColor: "bg-gray-600", textColor: "text-white" }; // Default colors
  };

  const handleProgramClick = async (
    programTypeId: string,
    // programTypeName: string,
  ) => {
    navigate("/admin/add-program/hdb", {
      state: { programTypeId: programTypeId },
    });
    setLoading(true);

    // try {
    //   const response = await getCall(
    //     `${endPoints.programType}/${programTypeId}`,
    //   );
    //   console.log("Program Type Details Response:", response?.data);

    //   if (response?.data) {
    //     console.log("Fetched Program Type Details:", response.data);

    //     // Store program type details
    //     const programTypeDetails = response.data;
    //     console.log("Fetched Program Type Details:", programTypeDetails);
    //     // Store in local storage or state management if needed

    //     // Navigate to add program page with the details
    //     navigate("/admin/add-program/hdb", {
    //       state: { programType: programTypeDetails },
    //     });
    //   } else {
    //     console.error("No program type details found");
    //     // Handle error - show toast or error message
    //   }
    // } catch (error) {
    //   console.error("Error fetching program type details:", error);
    //   // Handle error - show toast or error message
    // } finally {
    //   setLoading(false);
    // }
  };

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    } else {
      navigate("/admin/action-cards");
    }
  };

  return (
    <div className={styles.container}>
      {loading && <Loader type="large" />}
      <div className={styles.mainContent}>
        <div className={styles.mainBody}>
          <div className={styles.contentWrapper}>
            <div className={styles.titleSection}>
              <div className={styles.titleWithBack}>
                <div>
                  <div className={styles.mainTitle}>
                    {/* <button
                      onClick={handleBackClick}
                      className={styles.backButton}
                    >
                      <ArrowLeft size={24} />
                    </button> */}
                    <img src={ArrowLeft} alt="Back" onClick={handleBackClick} />
                    Create program
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p className={styles.subtitle}>
                Create a program from existing templates
              </p>
            </div>

            <div className={styles.programGrid}>
              {programTypesData.map((programType) => {
                const colors = getProgramColors(programType.name);
                const programClass = getProgramClass(programType.name);
                const programImage = programType.bannerUrl;

                return (
                  <div
                    key={programType.id}
                    onClick={() =>
                      handleProgramClick(programType.id, programType.name)
                    }
                    className={styles.programCard}
                  >
                    <div
                      className={`${styles.programCardImage} ${styles[programClass]}`}
                    >
                      <div className={styles.bannerContainer}>
                        <img src={programImage} alt={programType.name} />
                      </div>
                    </div>
                    <div className={styles.programCardContent}>
                      <h3 className={styles.programTitle}>
                        {programType.name}
                      </h3>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* <div className={styles.orDivider}>
              <div className={styles.grayLine}></div>
              <p className={styles.orText}>or create new</p>
              <div className={styles.grayLine}></div>
            </div>

            <div className={styles.optionsGrid}>
              <div className={styles.optionCard}>
                <img src={table} alt="Table" className={styles.optionIcon} />
                <h3 className={styles.optionTitle}>Create program</h3>
                <p className={styles.optionSubtitle}>Using form builder</p>
              </div>
              <div className={styles.optionCard}>
                <div className={styles.optionIcon}>
                  <Sparkles size={32} className="text-gray-600" />
                </div>
                <h3 className={styles.optionTitle}>Suggest a program</h3>
                <p className={styles.optionSubtitle}>Using preset attributes</p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseProgramPage;
